/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
// NOTE: its empty for now, but we might wanna add something in the future
export type State = NonNullable<unknown>
export namespace State {
  export const INITIAL: State = {}
}
